module.exports = __webpack_public_path__ + "img/home-dashboard.34efc83d.png";